export function escapeMarkdown(url: string) {
  return url
    .replace(/%5F/g, "_")
    .replace(/%2A/g, "*")
    .replace(/%28/g, "(")
    .replace(/%29/g, ")")
    .replace(/%7E/g, "~");
}

export function unescapeMarkdown(url: string) {
  return url
    .replace(/_/g, "%5F")
    .replace(/\*/g, "%2A")
    .replace(/\(/g, "%28")
    .replace(/\)/g, "%29")
    .replace(/~/g, "%7E");
}
